// SVG-Path-Builder fuer Connector-Verlaeufe. Pure Funktion, vitest-tauglich.
// straight = Linie, curved = kubische Bezier (wie tree-parent), orthogonal = Elbow
// mit 1-2 rechtwinkligen Ecken (Achsen-Heuristik). Koordinaten sind bereits in
// SVG-Space (Caller addiert den Worldspace-Offset).

import type { LinkRouting } from "@ms-whiteboard/shared";

export function buildLinkPath(
  routing: LinkRouting,
  sx: number,
  sy: number,
  ex: number,
  ey: number,
): string {
  if (routing === "curved") {
    const midX = (sx + ex) / 2;
    return `M ${sx},${sy} C ${midX},${sy} ${midX},${ey} ${ex},${ey}`;
  }
  if (routing === "orthogonal") {
    if (Math.abs(ex - sx) >= Math.abs(ey - sy)) {
      const midX = (sx + ex) / 2;
      return `M ${sx},${sy} L ${midX},${sy} L ${midX},${ey} L ${ex},${ey}`;
    }
    const midY = (sy + ey) / 2;
    return `M ${sx},${sy} L ${sx},${midY} L ${ex},${midY} L ${ex},${ey}`;
  }
  return `M ${sx},${sy} L ${ex},${ey}`;
}
